import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateSmtpCredential } from '../../helpers/api_helper';

const useUpdateSmtpCredential = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const updateSmtpCredentialHook = async (id, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updateSmtpCredential(tenantId, id, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to update SMTP credential: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { updateSmtpCredential: updateSmtpCredentialHook, loading, error };
};

export default useUpdateSmtpCredential;